
<template>
   <qrcode-vue :value="value" :size="width" />
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  props: {
    width: {
      type: Number,
      default: 130,
    },
    value: {
      type: String,
      default: undefined,
    },
  },
  components: {
    QrcodeVue
  },
};
</script>
